import { BetaChartCard } from 'src/pages/reports/components/beta-charts';
import { BetaChartAreaSkeleton } from 'src/pages/reports/components/beta-charts/beta-chart-skeletons';
import { formatCompactNumber } from './overview-beta-format';

export interface FunnelStep {
  label: string;
  value: number;
  colour: string;
}

interface OverviewBetaFunnelProps {
  steps: FunnelStep[];
  isLoading?: boolean;
}

export function OverviewBetaFunnel({ steps, isLoading = false }: OverviewBetaFunnelProps) {
  const max = Math.max(...steps.map((step) => step.value), 1);

  return (
    <BetaChartCard
      title="Conversion Funnel"
      subtitle="Impressions → Clicks → Conversions"
      className="mb-0"
    >
      {isLoading ? (
        <BetaChartAreaSkeleton className="h-[220px]" />
      ) : (
        <div className="space-y-2.5 py-1">
          {steps.map((step, index) => {
            const widthPct = Math.max((step.value / max) * 100, 4);
            const prev = index > 0 ? steps[index - 1].value : null;
            const rate = prev && prev > 0 ? (step.value / prev) * 100 : null;

            return (
              <div
                key={step.label}
                className="flex items-center gap-3.5"
              >
                <div className="w-[110px] shrink-0 text-right text-[12.5px] font-semibold text-[#5E6278]">
                  {step.label}
                </div>
                <div className="relative h-9 flex-1">
                  <div
                    className="flex h-full items-center rounded px-3 transition-[width] duration-500"
                    style={{ width: `${widthPct}%`, backgroundColor: step.colour }}
                  >
                    <span className="whitespace-nowrap text-[12.5px] font-bold text-white">
                      {formatCompactNumber(step.value)}
                    </span>
                  </div>
                </div>
                <div className="w-[90px] shrink-0">
                  <div className="font-mono text-xs font-semibold text-[#0D0F1A]">
                    {formatCompactNumber(step.value)}
                  </div>
                  {rate != null ? (
                    <div className="text-[11px] text-[#9CA3AF]">
                      {rate.toFixed(1)}
                      % of prior
                    </div>
                  ) : (
                    <div className="text-[11px] text-[#9CA3AF]">
                      Top of funnel
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </BetaChartCard>
  );
}
